(() => {
  if (window.earthleCallInstalled) return;
  window.earthleCallInstalled = true;
  const config = JSON.parse(document.querySelector('[data-en-config]')?.textContent || '{}');
  const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
  const money = window.EarthleMoney || (cents => new Intl.NumberFormat(document.documentElement.lang || 'nl', {style:'currency', currency:config.currency || 'EUR'}).format(cents / 100));
  const form = document.querySelector('#earthle-koop');
  const group = form?.querySelector('[data-en-quantity]');
  const variants = JSON.parse(group?.querySelector('[data-en-variants]')?.textContent || '[]');
  const find = id => variants.find(v => String(v.id) === String(id));
  const base = () => find(form?.querySelector('[data-variant-veld]')?.value) || variants[0];
  const enCountValue = (value, minimum = 1) => {
    const number = Math.floor(Number(value));
    return Number.isSafeInteger(number) ? Math.max(minimum, number) : minimum;
  };
  const enTier = quantity => quantity >= 3 ? 10 : quantity === 2 ? 5 : 0;
  const enTotal = lines => lines.reduce((sum, line) => sum + line.quantity, 0);
  function enResizeLines(lines, selectedId, target) {
    target = enCountValue(target);
    const result = lines.map(line => ({...line}));
    let delta = target - enTotal(result);
    if (delta > 0) {
      const line = result.find(line => line.id === selectedId);
      if (line) line.quantity += delta;
      else result.push({id:selectedId, quantity:delta});
    } else if (delta < 0) {
      // Remove from the selected finish first, preserving other choices where possible.
      const order = [...result.filter(line => line.id === selectedId), ...result.filter(line => line.id !== selectedId).reverse()];
      for (const line of order) {
        const removed = Math.min(line.quantity, -delta);
        line.quantity -= removed;
        delta += removed;
        if (!delta) break;
      }
    }
    return result.filter(line => line.quantity > 0);
  }
  function enSetLine(lines, id, quantity) {
    const result = lines.filter(line => line.id !== id).map(line => ({...line}));
    quantity = enCountValue(quantity, 0);
    if (quantity) result.push({id, quantity});
    if (!result.length) result.push({id, quantity:1});
    return result;
  }
  function state() {
    const variant = base();
    if (!group || !variant) return [];
    if (!group._enLines) group._enLines = [{id:String(variant.id),quantity:1}];
    if (group.dataset.baseVariant !== String(variant.id)) {
      if (!group.dataset.mixTouched) group._enLines = [{id:String(variant.id),quantity:enTotal(group._enLines)}];
      group.dataset.baseVariant = String(variant.id);
    }
    return group._enLines;
  }
  const count = () => enTotal(state());
  const rate = n => Number(group?.querySelector('[data-en-count="'+Math.min(n,3)+'"]')?.dataset.enOff || 0);
  function resize(value) {
    if (!base()?.available) return;
    group._enLines = enResizeLines(state(),String(base().id),value);
    syncQuantity();
  }
  function changeMix(input) {
    if (input.disabled) return;
    group.dataset.mixTouched = '1';
    group._enLines = enSetLine(state(),input.dataset.enMixCount,input.value);
    syncQuantity();
  }
  const selectedAddons = () => [...document.querySelectorAll('[data-en-addon][form="earthle-koop"]:checked')]
    .filter(input => Number(input.value) > 0)
    .map(input => ({id:Number(input.value), price:Number(input.dataset.price), rate:Number(input.dataset.off || 0)}));
  const addonsTotal = () => selectedAddons().reduce((sum,item) => sum + item.price - Math.floor(item.price * item.rate / 100), 0);
  function syncQuantity() {
    const variant = base();
    if (!group || !variant) return;
    group.hidden = !variant.available;
    const guide = JSON.parse(document.querySelector('[data-en-guide-data]')?.textContent || '{}');
    const pictures = guide[group.dataset.productId]?.[variant.id] || [];
    document.querySelectorAll('[data-en-guide-picture]').forEach(image => {
      const src = pictures[Number(image.dataset.enGuidePicture)];
      if (src) image.src = src;
      image.hidden = !src;
    });
    const chosen = state();
    group.querySelector('[data-en-amount]').value = String(count());
    group.querySelector('[data-en-step="-1"]').disabled = count() <= 1;
    group.querySelectorAll('[data-en-mix-count]').forEach(input => {
      const quantity = chosen.find(line => line.id === input.dataset.enMixCount)?.quantity || 0;
      input.value = String(quantity);
      input.previousElementSibling.disabled = input.disabled || quantity === 0 || (count() === 1 && quantity === 1);
    });
    group.querySelectorAll('[data-en-count]').forEach(button => {
      const n = Number(button.dataset.enCount);
      button.setAttribute('aria-pressed',String(n === Math.min(count(),3)));
      button.querySelector('[data-en-offer-total]').textContent = money(variant.price - Math.floor(variant.price * Number(button.dataset.enOff) / 100));
      button.querySelectorAll('.en-quantity__pictures img').forEach(image => {if (variant.image) image.src = variant.image;});
      button.disabled = !variant.available;
    });
    const input = form.querySelector('[name="quantity"]');
    if (input) input.value = String(count());
    // Match Shopify rounding; rates default to zero until real Earthle rules are activated.
    const percent = rate(count());
    const total = state().reduce((sum,line) => {
      const item = find(line.id);
      return sum + line.quantity * (item.price - Math.floor(item.price * percent / 100));
    },0) + addonsTotal();
    document.querySelectorAll('[data-en-total],[data-en-inline-total],[data-en-sticky-total]').forEach(el => { el.textContent = money(total); });
    const purchaseButton = form.querySelector('[type="submit"]');
    const purchaseBusy = Boolean(purchaseButton?.dataset.enBusy);
    document.querySelectorAll('[data-en-inline-label]').forEach(label => {
      if (purchaseButton?.dataset.addLabel) label.textContent = purchaseButton.dataset.addLabel;
    });
    document.querySelectorAll('[data-en-inline-purchase]').forEach(block => { block.hidden = !variant.available; });
    document.querySelectorAll('[data-en-inline-buy]').forEach(button => { button.disabled = !variant.available || purchaseBusy; });
    document.querySelectorAll('[data-en-addon-buy]').forEach(button => { button.hidden = selectedAddons().length === 0; });
    document.querySelectorAll('[data-en-buy]').forEach(button => {
      button.disabled = !variant.available || Boolean(button.dataset.enBusy) || purchaseBusy;
      if (purchaseBusy) button.setAttribute('aria-busy','true');
      else button.removeAttribute('aria-busy');
      button.querySelector('[data-en-buy-content]').hidden = !variant.available;
      button.querySelector('[data-en-sold-out]').hidden = variant.available;
    });
  }
  const lines = () => {
    const map = new Map();
    [...state(), ...selectedAddons().map(item => ({id:String(item.id),quantity:1}))].forEach(item => map.set(Number(item.id), (map.get(Number(item.id)) || 0) + item.quantity));
    return [...map].map(([id, quantity]) => ({id, quantity}));
  };
  document.addEventListener('earthle:variant-change', syncQuantity);
  document.addEventListener('input', event => {
    if (event.target.value === '' || !event.target.validity?.valid) return;
    if (event.target.matches('[data-en-amount]')) resize(event.target.value);
    if (event.target.matches('[data-en-mix-count]')) changeMix(event.target);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-en-amount]')) resize(event.target.value);
    if (event.target.matches('[data-en-mix-count]')) changeMix(event.target);
    if (event.target.matches('select[data-en-card-variant]')) {
      const option = event.target.selectedOptions[0];
      const card = event.target.closest('[data-en-product-id]');
      if (option?.dataset.price) card.querySelector('[data-en-card-price]').textContent = money(Number(option.dataset.price));
      if (option?.dataset.image) card.querySelector('a img').src = option.dataset.image;
      const oldPrice = card.querySelector('.en-product__price s');
      if (oldPrice) {
        oldPrice.hidden = Number(option?.dataset.compare || 0) <= Number(option?.dataset.price || 0);
        oldPrice.textContent = money(Number(option?.dataset.compare || 0));
      }
    }
  });
  document.addEventListener('click', event => {
    const reviewArrow = event.target.closest('[data-en-review-step]');
    if (reviewArrow) {
      const rail = reviewArrow.closest('.revs-wrap,.en-review-stage')?.querySelector('[data-rev-rail]');
      if (rail) {
        const card = rail.querySelector('.rev');
        const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 16;
        const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * .85;
        rail.scrollBy({left:distance * Number(reviewArrow.dataset.enReviewStep), behavior:event.detail === 0 || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    }
    const option = event.target.closest('[data-en-count]');
    if (option && !option.disabled) {
      const n = Number(option.dataset.enCount);
      resize(n === 3 ? Math.max(3,count()) : n);
    }
    const step = event.target.closest('[data-en-step]');
    if (step) resize(Number(group.querySelector('[data-en-amount]').value) + Number(step.dataset.enStep));
    const mixStep = event.target.closest('[data-en-mix-step]');
    if (mixStep) {
      const input = mixStep.parentElement.querySelector('[data-en-mix-count]');
      input.value = String(Math.max(0,Number(input.value) + Number(mixStep.dataset.enMixStep)));
      changeMix(input);
    }
    if (event.target.closest('[data-en-inline-buy]')) {
      const button = form?.querySelector('[type="submit"]');
      if (button && !button.disabled) form.requestSubmit(button);
    }
    const arrow = event.target.closest('[data-en-prev],[data-en-next]');
    if (arrow) {
      const rail = document.getElementById(arrow.getAttribute('aria-controls'));
      rail?.scrollBy({left:rail.clientWidth * .85 * (arrow.hasAttribute('data-en-prev') ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
  function railState(rail) {
    const section = rail.closest('[data-en-products]');
    const max = rail.scrollWidth - rail.clientWidth;
    const previous = section?.querySelector('[data-en-prev]');
    const next = section?.querySelector('[data-en-next]');
    if (previous) previous.disabled = rail.scrollLeft < 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
    const nav = section?.querySelector('[data-en-rail-nav]');
    if (nav) nav.hidden = max < 2;
  }
  document.querySelectorAll('[data-en-rail]').forEach(rail => {
    rail.addEventListener('scroll', () => railState(rail), {passive:true});
    new ResizeObserver(() => railState(rail)).observe(rail);
    rail.querySelectorAll('img').forEach(image => image.addEventListener('load', () => railState(rail), {once:true}));
    railState(rail);
  });
  function updateCart(cart) {
    document.querySelectorAll('[data-en-checkout-total]').forEach(el => { el.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-en-free-shipping]').forEach(el => {
      const remaining = Math.max(0, Number(config.threshold || 0) - cart.total_price);
      const progress = Math.min(100, cart.total_price / Number(config.threshold || 1) * 100);
      el.querySelector('p').textContent = remaining ? config.text.freeLeft.replace('__AMOUNT__', money(remaining)) : config.text.freeDone;
      const track = el.querySelector('[role="progressbar"]');
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
      track.querySelector('span').style.width = progress + '%';
    });
    const ids = new Set(cart.items.map(item => String(item.product_id)));
    document.querySelectorAll('.en-products--cart,.en-products--cart-page').forEach(section => {
      section.querySelectorAll('[data-en-product-id]').forEach(card => { card.hidden = ids.has(card.dataset.enProductId); });
      section.hidden = ![...section.querySelectorAll('[data-en-product-id]')].some(card => !card.hidden);
      railState(section.querySelector('[data-en-rail]'));
    });
  }
  let refreshVersion = 0;
  async function refreshCart() {
    const version = ++refreshVersion;
    try {
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (version === refreshVersion) updateCart(cart);
    } catch (_) { /* The native cart remains available after a failed background refresh. */ }
  }
  async function addItems(items, button, status) {
    if (button.dataset.enBusy) return;
    button.dataset.enBusy = '1';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    const mainPurchase = button === form?.querySelector('[type="submit"]');
    if (mainPurchase) syncQuantity();
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status) { const error = new Error(); error.customerMessage = result.description || config.text.addError; throw error; }
      if (document.querySelector('#CartDrawer')) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:result.items?.[0] || result, addToCartBtn:button}}));
      } else {
        const cartURL = new URL(root + 'cart', location.origin);
        if (config.preview) cartURL.searchParams.set('preview_theme_id', config.preview);
        location.assign(cartURL.href);
      }
      refreshCart();
    } catch (error) {
      // Never repeat the POST automatically: it may already have reached Shopify.
      status.textContent = error.customerMessage || config.text.addError;
    } finally {
      delete button.dataset.enBusy;
      button.removeAttribute('aria-busy');
      if (mainPurchase) syncQuantity();
      else button.disabled = false;
    }
  }
  if (form && group) {
    const status = document.createElement('p');
    status.className = 'en-add-status';
    status.setAttribute('role', 'status');
    form.appendChild(status);
    document.addEventListener('submit', event => {
      if (event.target !== form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('[type="submit"]');
      if (button && !button.disabled && base()?.available) addItems(lines(), button, status);
    }, true);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-en-quick-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const card = button.closest('[data-en-product-id]');
    addItems([{id:Number(card.querySelector('[data-en-card-variant]').value), quantity:1}], button, card.querySelector('[data-en-status]'));
  });
  const bundle = document.querySelector('[data-en-bundle]');
  function bundleTotal() {
    if(!bundle)return;
    const rate = Number(bundle.dataset.rate || 0);
    const selects = [...bundle.querySelectorAll('[data-en-bundle-variant]')];
    const total = selects.reduce((n,s) => n + Number(s.selectedOptions[0]?.dataset.price || 0), 0);
    const discounted = selects.reduce((n,s) => { const p=Number(s.selectedOptions[0]?.dataset.price || 0); return n+p-Math.floor(p*rate/100); }, 0);
    selects.forEach(select => {
      const card = select.closest('[data-en-bundle-product]');
      const option = select.selectedOptions[0];
      if (option?.dataset.image) card.querySelector('[data-en-bundle-image]').src=option.dataset.image;
      card.querySelector('[data-en-bundle-price]').textContent=money(Number(option?.dataset.price || 0));
    });
    bundle.querySelector('[data-en-bundle-total]').textContent=money(discounted + addonsTotal());
    const was=bundle.querySelector('[data-en-bundle-was]'); was.hidden=!rate; was.textContent=money(total + addonsTotal());
    bundle.querySelector('[data-en-bundle-saving]').hidden=!rate;
    const button=bundle.querySelector('[data-en-bundle-add]');
    button.textContent=selectedAddons().length ? button.dataset.addSelected : button.dataset.addBoth;
    bundle.querySelector('[data-en-bundle-includes]').hidden=!selectedAddons().length;
  }
  document.addEventListener('change',event=>{if(event.target.matches('[data-en-addon]')){syncQuantity();bundleTotal();}if(event.target.matches('[data-en-bundle-variant]'))bundleTotal();});
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-en-bundle-add]');
    if(!button||button.disabled)return;
    const scope=button.closest('[data-en-bundle]');
    const items=[...scope.querySelectorAll('[data-en-bundle-variant]')].map(s=>({id:Number(s.value),quantity:1})).concat(selectedAddons().map(item=>({id:item.id,quantity:1})));
    addItems(items,button,scope.querySelector('[data-en-bundle-status]'));
  });
  bundleTotal();
  async function applyCode(button) {
    if (button.disabled) return;
    const scope = button.closest('.en-discount');
    const input = scope.querySelector('[data-en-code]');
    const status = scope.querySelector('[data-en-code-status]');
    const code = input.value.trim();
    if (!code) { input.focus(); return; }
    button.disabled = true;
    status.textContent = '';
    try {
      const response = await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({discount:code})});
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || config.text.error);
      const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
      const accepted = cart.discount_codes?.some(item => item.applicable && item.code.toLowerCase() === code.toLowerCase()) || applications.some(item => item?.type === 'discount_code' && item.title?.toLowerCase() === code.toLowerCase());
      status.textContent = accepted ? config.text.applied : config.text.error;
      updateCart(cart);
      if (accepted) document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (error) { status.textContent = error.message || config.text.error; }
    finally { button.disabled = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-en-apply]');
    if (button) applyCode(button);
    if (event.target.closest('.js-drawer-open-cart')) refreshCart();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-en-code]')) {
      event.preventDefault();
      event.stopPropagation();
      applyCode(event.target.closest('.en-discount').querySelector('[data-en-apply]'));
    }
  }, true);
  document.addEventListener('cart:updated', event => { if (event.detail?.cart) updateCart(event.detail.cart); else refreshCart(); });
  document.addEventListener('ajaxProduct:added', refreshCart);
  window.addEventListener('pageshow', refreshCart);
  syncQuantity();
})();

// Reinitialise payment rows when Shopify rebuilds the cart drawer.
(() => {
 function initPayments(){
  document.querySelectorAll('[data-en-payments]:not([data-payment-ready])').forEach(row=>{
   row.dataset.paymentReady='true';
   const rail=row.querySelector('.en-payments__scroller'),button=row.querySelector('.en-payments__next');
   if(!rail||!button)return;
   const sync=()=>{
    const overflow=rail.scrollWidth>rail.clientWidth+2,end=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;
    button.hidden=!overflow;button.classList.toggle('is-end',end);
    button.setAttribute('aria-label',end?button.dataset.firstLabel:button.dataset.nextLabel);
   };
   button.addEventListener('click',()=>{
    const end=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;
    rail.scrollTo({left:end?0:rail.scrollLeft+Math.max(rail.clientWidth*.75,72),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   });
   rail.addEventListener('scroll',sync,{passive:true});
   const observer=new ResizeObserver(()=>{if(row.isConnected)sync();else observer.disconnect();});observer.observe(rail);sync();
  });
 }
 initPayments();new MutationObserver(initPayments).observe(document.body,{childList:true,subtree:true});
})();

// Mobile review arrows share the rail's real start/end state.
(() => {
 function initReviewControls(){
  document.querySelectorAll('[data-rev-rail]:not([data-en-controls-ready])').forEach(rail=>{
   const stage=rail.closest('.revs-wrap,.en-review-stage');
   if(!stage)return;
   rail.dataset.enControlsReady='true';
   if(!rail.id)rail.id='en-review-'+(rail.closest('.shopify-section')?.id || 'product');
   const buttons=[...stage.querySelectorAll('[data-en-review-step]')];
   buttons.forEach(button=>button.setAttribute('aria-controls',rail.id));
   const sync=()=>{
    const max=rail.scrollWidth-rail.clientWidth;
    const bounds=rail.getBoundingClientRect(),stageBounds=stage.getBoundingClientRect();
    const cards=[...rail.querySelectorAll('.rev')];
    const leading=cards.find(card=>{const r=card.getBoundingClientRect();return r.left>=bounds.left-5&&r.left<bounds.right-10;}) || cards.find(card=>card.getBoundingClientRect().right>bounds.left+10);
    if(leading){const r=leading.getBoundingClientRect();stage.style.setProperty('--en-review-midpoint',(r.top-stageBounds.top+r.height/2)+'px');}
    buttons.forEach(button=>{
     button.disabled=max<=4 || (Number(button.dataset.enReviewStep)<0 ? rail.scrollLeft<=4 : rail.scrollLeft>=max-4);
    });
    const nav=stage.querySelector('.en-mobile-review-arrows');
    if(nav)nav.hidden=max<=4;
   };
   rail.addEventListener('scroll',sync,{passive:true});
   rail.addEventListener('keydown',event=>{
    if(event.target!==rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();
    const card=rail.querySelector('.rev');
    const step=(card?.getBoundingClientRect().width || rail.clientWidth*.85)+(Number.parseFloat(getComputedStyle(rail).columnGap)||16);
    const left=event.key==='Home'?0:event.key==='End'?rail.scrollWidth:rail.scrollLeft+step*(event.key==='ArrowLeft'?-1:1);
    rail.scrollTo({left,behavior:'instant'});
   });
   new ResizeObserver(sync).observe(rail);
   rail.querySelectorAll('img').forEach(image=>image.addEventListener('load',sync,{once:true}));
   sync();
  });
 }
 initReviewControls();
 document.addEventListener('shopify:section:load',initReviewControls);
})();
